import moment from 'moment';
import axios from "axios";
export function sortDate(a, b, key) {
    if ((key === 'created_at') || (key == 'date_last') || (key === 'date_annulation') || (key === 'date')) {
        if (a[key] === "" || a[key] === null || a[key] === "undefined") {
            return 1;
        }
        else if (b[key] === "" || b[key] === null || b[key] === "undefined") {
            return -1;
        }
        var multipleFormat = ['DD/MM/YYYY', 'DD.MM.YYYY', 'DD.MM.YYYY hh:mm', 'YYYY-MM-DD'];
        var aDate = moment(a[key], multipleFormat);
        var bDate = moment(b[key], multipleFormat);
        if (aDate.isValid() && bDate.isValid()) {
            if (aDate < bDate) {
                return -1;
            }
            else if (aDate > bDate) {
                return 1;
            }
            else {
                return 0;
            }
        }
        return null;
    }
    else if (key === 'date_sortie') {
        if (a[key] === "" || a[key] === null || a[key] === "undefined" || a[key] === "s.d.") {
            return 1;
        }
        else if (b[key] === "" || b[key] === null || b[key] === "undefined" || b[key] === "s.d.") {
            return -1;
        }
        var aString = a[key];
        if (aString.startsWith("[") && aString.endsWith("]")) {
            aString = aString.substring(1, aString.length - 1);
            if (aString.includes("-")) {
                aString = aString.split('-')[0];
            }
            if (aString.length < 2) {
                aString += '000';
            }
            if (aString.length < 3) {
                aString += '00';
            }
            if (aString.length < 4) {
                aString += '0';
            }
        }
        var bString = b[key];
        if (bString.startsWith("[") && bString.endsWith("]")) {
            bString = bString.substring(1, bString.length - 1);
            if (bString.includes("-")) {
                bString = bString.split('-')[0];
            }
            if (bString.length < 2) {
                bString += '000';
            }
            if (bString.length < 3) {
                bString += '00';
            }
            if (bString.length < 4) {
                bString += '0';
            }
        }
        var multipleFormat = ['DD/MM/YYYY', 'DD.MM.YYYY', 'DD.MM.YYYY hh:mm', 'YYYY-MM-DD', 'YYYY'];
        var aDate = moment(aString, multipleFormat);
        var bDate = moment(bString, multipleFormat);
        if (aDate.isValid() && bDate.isValid()) {
            if (aDate < bDate) {
                return -1;
            }
            else if (aDate > bDate) {
                return 1;
            }
            else {
                return 0;
            }
        }
        return null;
    }
    else if (key === 'date_create') {
        if (a[key] === "" || a[key] === null || a[key] === "undefined" || a[key] === "s.d.") {
            return 1;
        }
        else if (b[key] === "" || b[key] === null || b[key] === "undefined" || b[key] === "s.d.") {
            return -1;
        }
        var aDate = processDate(a[key]);
        var bDate = processDate(b[key]);
        if (aDate < bDate) {
            return -1;
        }
        else if (aDate > bDate) {
            return 1;
        }
        else {
            return 0;
        }
    }
    return null;
}
function processDate(date) {
    var parts = date.split("/");
    return new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
}
/**
 * HTTP GET
 * @param route
 * @param data
 */
export function get(route, data) {
    if (data === void 0) { data = null; }
    return axios.get(route, {
        params: data,
    });
}
/**
 * return formatted delayed date string (format: YYYY-MM-DD) to use in datepicker elements
 * @param today YYYY-MM-DD
 * @param days number of days to delay
 */
export function delay(today, days) {
    return new Date(new Date().setDate(new Date(today).getDate() + days)).toISOString().split('T')[0];
}
/**
 * Returns validation state of input for vee-validation component
 * @param dirty
 * @param validated
 * @param valid
 */
export function getValidationState(_a) {
    var dirty = _a.dirty, validated = _a.validated, _b = _a.valid, valid = _b === void 0 ? null : _b;
    return dirty || validated ? valid : null;
}
/**
 * Returns csrf token in meta tags of html page
 */
export function get_csrf_token() {
    var tag = document.querySelector('meta[name="csrf-token"]');
    if (tag) {
        var token = tag.getAttribute('content');
        if (token) {
            return token;
        }
    }
    return '';
}
export function stepBack() {
    window.history.back();
}
/**
 * Returns ids of all available groups
 * @param groups
 */
export function getGroupsIds(groups) {
    var groupsIds = [];
    Object.values(groups).forEach(function (group) {
        groupsIds.push(group.id);
    });
    return groupsIds;
}
/**
 * Return list of right names
 * @param rights
 */
export function getRightsName(rights) {
    var rightsName = [];
    Object.values(rights).forEach(function (right) {
        rightsName.push(right.name);
    });
    return rightsName;
}
